import * as React from 'react';
import { Modal, Button, ListingDetailsComponents } from 'components';
import { useBreakpoint } from 'hooks';
import { ListingFormState } from '../types';

interface ListingDetailsPreviewProps {
  listing: ListingFormState;
  photos?: any[];
  attachments: any[];
  disabled?: boolean;
}

const ListingDetailsPreview: React.FC<ListingDetailsPreviewProps> = ({
  listing,
  photos,
  attachments,
  disabled,
}) => {
  const { md } = useBreakpoint();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const closeModal = () => setIsModalOpen(false);
  return (
    <>
      <Button onClick={() => setIsModalOpen(true)} disabled={disabled}>
        Preview
      </Button>
      <Modal
        style={{ top: '20px' }}
        bodyStyle={{ padding: '5px' }}
        centered
        open={isModalOpen}
        onCancel={closeModal}
        closable={false}
        footer={null}
        width={md ? '90%' : '100%'}
      >
        <ListingDetailsComponents.ListingDetailsPage
          listing={listing}
          closeModal={closeModal}
          photos={photos}
          attachments={attachments}
        />
      </Modal>
    </>
  );
};

export default ListingDetailsPreview;
